
import { send as logSend } from 'smith-log';

import {
  getEasyApplySource
} from '@/utils/util.js';
import jobs from '@/utils/hotjob.js';
export default {
  head() {
    return {
      script: [
        {
          type: 'application/ld+json',
          json: this.structuredData
        }
      ],
      title: this.title + ' - Hirey',
      meta: [
        {  hid: 'description', name: 'description', content: this.description + ' - Hirey' },
      ]
    }
  },
  data() {
    return {
      structuredData: {
        "@context" : "https://schema.org/",
        "@type" : "JobPosting",
        "datePosted" : "",
        "title" : "",
        "description" : "",
        "jobLocation": {
          "@type": "Place",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "",
            "addressLocality": "",
            "addressRegion": "",
            "addressCountry": "",
          }
        },
        "hiringOrganization" : {
          "@type" : "Organization",
          "name" : "",
          "logo" : ""
        },
        "baseSalary": {
          "@type": "MonetaryAmount",
          "currency": "USD",
          "value": {
            "@type": "QuantitativeValue",
            "minValue": '',
            "maxValue": '',
            "unitText": ""
          }
        },
        "employmentType": ''
      },
      job: {},
      title: '',
      description: '',
      jobType: {
        1:'FULL_TIME',
        2:'INTERN',
        5:'CONTRACTOR',
      },
      unitText: {
        0: 'YEAR',
        1: 'MONTH',
        2: 'HOUR'
      },
      showForm: 1
    }
  },
  async fetch() {
    const id = this.$route.params.id
    // if (jobs.map(item => item.id).indexOf(id) > -1) {
    //   this.job = jobs.find(item => item.id === id)
    //   this.title = this.job.title
    //   this.description = this.job.detail
    //   return
    // }
    const res = await this.$api.jobseeker.getJob(id).catch(() => ({}))

    const data  = res.data?.data
    if (!data) {
      this.$nuxt.context.redirect({path:'/jobseeker/search' , query: { message: 'Sorry, the job has been closed. You can get more similar jobs by searching jobs.'}});
      return
    }
    this.job = data
    // console.log(data);
    this.structuredData.title = data.title
    this.structuredData.description = data.detail
    this.structuredData.hiringOrganization.name = data.company.fullName
    this.structuredData.hiringOrganization.logo = data.company.logo.replace(/hirect/g, 'hy')
    this.structuredData.datePosted = data.updateTime.split(' ')[0]

    this.structuredData.jobLocation.address.addressCountry = data.location.country ||  'US'
    this.structuredData.jobLocation.address.streetAddress = data.location.streetNumber
    this.structuredData.jobLocation.address.addressLocality = data.location.city.split(',')[0].trim()
    this.structuredData.jobLocation.address.addressRegion = data.location.city.split(',')[1].trim()

    this.structuredData.baseSalary.value.minValue = data.salaryMin
    this.structuredData.baseSalary.value.maxValue = data.salaryMax
    this.structuredData.baseSalary.value.unitText = this.unitText[Number(data.salaryUnit)]
    this.structuredData.employmentType = this.jobType[data.typeId]

    this.structuredData.jobLocation.address.streetAddress = data.location.address
    this.structuredData.validThrough = new Date(Date.now() + 365*24*60*60*1000).toISOString().split('T')[0]
    this.title = data.title
    this.description = data.detail
  },
  async mounted() {
    const jobDetailUIType = localStorage.getItem('jobDetailUIType')
    const deviceId = localStorage.getItem('deviceId')
    let source = getEasyApplySource()
    // if (jobDetailUIType) {
    //   this.showForm = JSON.parse(jobDetailUIType)
    // } else {
    //   this.showForm = (await this.$axios.get(`https://hirey.com/server/service/get-ui-type?deviceId=${deviceId}&source=${source}`).catch(() => ({data: {result: {type: 1}}}))).data.result.type
    //   localStorage.setItem('jobDetailUIType', JSON.stringify(this.showForm))
    // }
    // logSend('MV', 'e_abtest_job_detail', {
    //   deviceId,
    //   ui: this.showForm,
    //   source
    // })
    logSend('MV', 'e_ca_website_job_detail', {
      job_id: this.job.id,
      recruiter_id: this.job?.recruiter?.id,
      page_id: 'p_ca_website_job_detail',
      source
    })
  }
};
